import { Base } from '../base-component';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';

import './event-tile.component.scss';

export class EventTile extends Base {

	tabComponent: any;
    slideRunner: JQuery<HTMLElement>;
    activeTab: JQuery<HTMLElement>;
    tabsContent: Array<HTMLElement>;
    tabTriggers: Array<HTMLElement>;
    activeTabTrigger: JQuery<HTMLElement>;
    autoHeight: string = 'true';
    dropdown: any;

    constructor(element: Element) {

        super(element);

    }

    init() {
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.event-tile__item-content'));

        setTimeout(() => {
            this.equalHeights();
        }, 100);

        this.initTabs();

        this.slideRunner = this.tabComponent.find('.event-tile__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.event-tile__item--active');
        this.activeTab = this.tabComponent.find('.event-tile__item-content--active');

        this.dropdown = this.element.querySelector('.js-option-selector');
        this.slideRunner = this.tabComponent.find('.event-tile__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.event-tile__item--active');
        this.activeTab = this.tabComponent.find('.event-tile__item-content--active');

        $(document).ready(() => {
            this.moveSlideRunner();
        });

    }

    bindEvents() {

        this.tabTriggers.map((item) => item.addEventListener('click', (event) => {

            this.toggleTabs(event);
            this.moveSlideRunner();

        }));

        window.addEventListener('resize', this.debounce(() => {

            this.moveSlideRunner();

        }, 250, false));

        window.addEventListener('resize', this.onResize.bind(this));

        this.dropdown.addEventListener('change', (event)=>{ 
            let element = event.target;
            let index = element.selectedIndex;
            let value = element.value;
            this.dropdownSelection(value, index);
        })

    }

    onResize() {

        setTimeout(() => {
            this.equalHeights();
        }, 100);

    }

    initTabs() {

        let tabs = this.tabComponent.find('.event-tile__item');
        let tabsContent = this.tabsContent;

        for (let i = 0; i < tabs.length; i++) {

            let tabGuid = this.generateGuid();

            $(tabs[i]).attr('data-target', `event-tile__item-${tabGuid}`);
            $(tabsContent[i]).attr('id', `event-tile__item-${tabGuid}`);

        }

    }

    equalHeights() {
        if (this.autoHeight == 'true') {
            let elements = this.tabsContent;

            for (let i = 0; i < elements.length; i++) {
                if (!elements[i].classList.contains('event-tile__item-content--active')) {
                    elements[i].style.height = '0';
                }else{
                    elements[i].style.height = 'auto';
                }
            }

            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

                let tallestElement = 0;

                for (let i = 0; i < elements.length; i++) {
                    let el = elements[i];
                    
                    if(el.classList.contains('event-tile__item-content--active')){
                        let elHeight = el.offsetHeight;

                        if (elHeight > tallestElement) {
                            tallestElement = elHeight;
                        }
                    }
                }

                for (let i = 0; i < elements.length; i++) {

                    elements[i].style.height = `${tallestElement}px`;

                    if (!elements[i].classList.contains('event-tile__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    }

    toggleTabs(event) {

        if (!$(event.currentTarget).hasClass('event-tile__item--active')) {

            this.closeTab();

            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find(`#${this.activeTabTrigger.attr('data-target')}`);

            this.openTab();

        }

        this.equalHeights();

    }

    moveSlideRunner() {

        let tabPositionLeft = this.activeTabTrigger.position().left;
        let tabWidth = this.activeTabTrigger.width();

        this.slideRunner
            .width(0)
            .css('left', `${tabPositionLeft}px`)
            .show()
            .delay(350)
            .width(tabWidth);

    }

    generateGuid() {

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);

        });

    }

    closeTab() {

        this.activeTabTrigger.removeClass('event-tile__item--active');
        this.activeTab.removeClass('event-tile__item-content--active');

    }

    openTab() {

        this.activeTabTrigger.addClass('event-tile__item--active');
        this.activeTab.addClass('event-tile__item-content--active');

    }

    debounce(func, wait, immediate) {
        let timeout;
        return function () {

            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);

        };
    }

    dropdownSelection(value, index){

        if(index == 0)
        {
            index = 4;
        }
        if(index && value) {
            if(index == 4)
            {
                index = 0;
            }
            this.tabsContent.map((item, indexContent)=>{
                item.classList.remove('event-tile__item-content--active');
                item.style.height = '0';
                if(indexContent === index) {
                    item.classList.add('event-tile__item-content--active');
                    item.style.height = 'auto';
                }
            })

            this.tabTriggers.map((item, indexTabItem)=>{
                item.classList.remove('event-tile__item--active');
                if(indexTabItem === index) {
                    item.classList.add('event-tile__item--active');
                }
            })

        }
    }

}



// WEBPACK FOOTER //
// ./components/event-tile/event-tile.component.ts